/** Pure helpers for the live shared-Q&A UI: client-side vote tracking + the
 *  question-text guard. The SERVER is the authority on vote dedup and ordering;
 *  these are purely client affordances (disable an already-cast vote; reject an
 *  obviously-bad question before the round-trip). No DOM, no I/O. */

/** Per-session localStorage key for the set of question ids this browser upvoted. */
export function votedStorageKey(sessionId: string): string {
  return `deck:live:voted:${sessionId}`;
}

/** Parse the stored voted-ids JSON array into a Set. Tolerates absent/garbage. */
export function loadVotedQids(raw: string | null): Set<string> {
  if (!raw) return new Set();
  try {
    const arr: unknown = JSON.parse(raw);
    if (!Array.isArray(arr)) return new Set();
    return new Set(arr.filter((x): x is string => typeof x === 'string'));
  } catch {
    return new Set();
  }
}

/** Serialise a voted-ids Set back to a JSON array string for storage. */
export function serializeVotedQids(voted: Set<string>): string {
  return JSON.stringify([...voted]);
}

/** Max question length — mirrors the server's maxQuestionLen. */
export const MAX_QUESTION_LEN = 280;

/** Trim + length-validate a question. Returns the cleaned text, or null when it
 *  is empty/whitespace or over the limit. */
export function cleanQuestionText(input: string): string | null {
  const t = input.trim();
  if (t.length === 0 || t.length > MAX_QUESTION_LEN) return null;
  return t;
}
